
export default class Card {
  id;
  created_at;
  title: string;
  name: string;
  slug: string;
  date: string;
  modified: string;
  status: string;
  type: string;
  description: string;
  link: string;
  img;

  auction;
  adress;
  user;
  statut;

  constructor(id, json) {

    if (!json) { return; }

    this.id = id || 0;
    this.created_at = this.created_at || {};
    this.img = json.selfie || false;
    this.title = json.title || false;
    this.name = json.name || false;
    this.auction = json.auction || false;
    this.user = json.user || false;
    this.adress = json.adress || false;
    this.type = json.type || false;
    this.statut = json.statut || 0;
  }

  getstatut(size: number = 100): string {
    return 'this.img_twitter';
  }

}



// WEBPACK FOOTER //
// ./src/models/card.model.ts